import { render, staticRenderFns } from "./we-service.vue?vue&type=template&id=afdeb1ea&scoped=true"
import script from "./we-service.vue?vue&type=script&lang=js"
export * from "./we-service.vue?vue&type=script&lang=js"
import style0 from "./we-service.vue?vue&type=style&index=0&id=afdeb1ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdeb1ea",
  null
  
)

export default component.exports